export const features = {
  path_finder: 'PATH_FINDER_SUBSCRIPTION', 
};

export const featureLabels = {
  [features.path_finder]: 'Pathfinder',
};